import * as Sentry from "@sentry/react";

Sentry.init({
  environment: process.env.SENTRY_ENV,
  dsn: process.env.SENTRY_URL
});
